import type {
  AccessLevelOnIconView,
  UserAccess,
} from 'shared/domain/issue/mapping/accessLevel/toOnView/types';
import type { UserRole } from 'shared/types/userRole';
import { createAccessLevel } from '../model/createAccessLevel';
import { accessLevelModelToOnIconView } from './accessLevelModeltoOnIconView';

export function getAccessLevelOnIconView(
  issueUserAccesses: UserAccess[],
  userId: string,
  userRole: UserRole
): AccessLevelOnIconView {
  const userAccessLevel = createAccessLevel(
    issueUserAccesses,
    userId,
    userRole
  );
  return accessLevelModelToOnIconView(userAccessLevel);
}
